import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import { useState } from 'react';
import { isValidNumberInputKey, strToInteger } from '@/utils/numbers';
import { Label, Input } from '@/components/FormElements';
import Button from '@/components/Button';
import Tooltip from '@/components/Tooltip';
import RevealPill from '@/components/Editor/Form/fields/RevealPill';
import parentStyles from '@/features/WidgetEdit/Form/styles.module.scss';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var InfoIcon = function InfoIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0Z",
      fill: "#D8DAE6"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10 5C9.44772 5 9 5.44772 9 6C9 6.55228 9.44772 7 10 7C10.5523 7 11 6.55228 11 6C11 5.44772 10.5523 5 10 5Z",
      fill: "#696C80"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10V14C9 14.5523 9.44772 15 10 15C10.5523 15 11 14.5523 11 14V10Z",
      fill: "#696C80"
    })]
  }));
};

InfoIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var PercentIcon = function PercentIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M13.2552 0.585279C12.7505 0.328492 12.133 0.529696 11.8763 1.03465L4.2493 16.0359C3.99258 16.5408 4.19378 17.1581 4.69867 17.4148C4.84758 17.4905 5.00626 17.5263 5.16261 17.5263C5.53631 17.5263 5.89653 17.3214 6.07757 16.9654L13.7046 1.96417C13.9613 1.45928 13.7601 0.841997 13.2552 0.585279Z",
      fill: "#9A9EB3"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.77866 5.52514C7.77866 3.38054 6.03386 1.63574 3.88926 1.63574C1.74479 1.63574 0 3.38054 0 5.52514C0 7.66967 1.74479 9.41447 3.88933 9.41447C6.03393 9.41447 7.77866 7.66967 7.77866 5.52514ZM3.88933 7.36346C2.87572 7.36346 2.05101 6.53875 2.05101 5.52514C2.05101 4.51146 2.87572 3.68675 3.88933 3.68675C4.90301 3.68675 5.72772 4.51139 5.72772 5.52514C5.72765 6.53875 4.90301 7.36346 3.88933 7.36346Z",
      fill: "#9A9EB3"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.1106 8.58545C11.966 8.58545 10.2212 10.3302 10.2212 12.4748C10.2212 14.6193 11.9659 16.3641 14.1106 16.3641C16.2551 16.3641 17.9999 14.6194 17.9999 12.4748C17.9999 10.3302 16.2552 8.58545 14.1106 8.58545ZM14.1106 14.313C13.0969 14.313 12.2722 13.4883 12.2722 12.4747C12.2722 11.4611 13.0969 10.6364 14.1106 10.6364C15.1242 10.6364 15.9489 11.4611 15.9489 12.4747C15.9489 13.4883 15.1243 14.313 14.1106 14.313Z",
      fill: "#9A9EB3"
    })]
  }));
};

PercentIcon.defaultProps = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ChartTwoColumnsIcon = function ChartTwoColumnsIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_7906_820)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13 -1.31134e-07C11.3431 -5.87108e-08 10 1.34315 10 3L10 13C10 13.5523 10.4477 14 11 14C11.5523 14 12 13.5523 12 13L12 3C12 2.44772 12.4477 2 13 2C13.5523 2 14 2.44772 14 3L14 13C14 13.5523 14.4477 14 15 14C15.5523 14 16 13.5523 16 13L16 3C16 1.34315 14.6569 -2.03558e-07 13 -1.31134e-07Z",
        fill: "#252833"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 6C3.34315 6 2 7.34315 2 9L2 13C2 13.5523 2.44772 14 3 14C3.55228 14 4 13.5523 4 13L4 9C4 8.44772 4.44772 8 5 8C5.55228 8 6 8.44772 6 9L6 13C6 13.5523 6.44772 14 7 14C7.55228 14 8 13.5523 8 13L8 9C8 7.34315 6.65685 6 5 6Z",
        fill: "#252833"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M-4.37114e-08 17C-6.78525e-08 16.4477 0.447715 16 1 16L17 16C17.5523 16 18 16.4477 18 17C18 17.5523 17.5523 18 17 18L1 18C0.447715 18 -1.95703e-08 17.5523 -4.37114e-08 17Z",
        fill: "#252833"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_7906_820",
        children: /*#__PURE__*/_jsx("rect", {
          width: "18",
          height: "18",
          fill: "white",
          transform: "translate(0 18) rotate(-90)"
        })
      })
    })]
  }));
};

ChartTwoColumnsIcon.defaultProps = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const EditorFormFieldsColumnDesign = _ref => {
  let {
    nameSpace,
    label = 'Column Design',
    barPercentage,
    categoryPercentage,
    defaults = {},
    openButtonVariant,
    onChange
  } = _ref;
  const {
    0: updatedAt,
    1: setUpdatedAt
  } = useState(Date.now());
  const barPercentageFieldId = `${nameSpace}-barPercentage`;
  const categoryPercentageFieldId = `${nameSpace}-categoryPercentage`;
  const isModified = Boolean(barPercentage || categoryPercentage);

  const handleDelete = () => {
    // Reset all values to null
    onChange({
      barPercentage: null,
      categoryPercentage: null
    });
    setUpdatedAt(Date.now());
  };

  return /*#__PURE__*/_jsx(RevealPill, {
    label: label,
    activeState: /*#__PURE__*/_jsx(ChartTwoColumnsIcon, {}),
    classNames: {
      floating: styles.floating
    },
    variant: isModified ? 'active' : '',
    openButtonVariant: openButtonVariant,
    children: /*#__PURE__*/_jsxs("div", {
      className: parentStyles.formField,
      children: [/*#__PURE__*/_jsxs("div", {
        className: parentStyles.formField__grid,
        children: [/*#__PURE__*/_jsx(PercentageInput, {
          id: barPercentageFieldId,
          label: "Bar Thickness",
          tooltip: "Adjust the thickness of the individual bars in the chart.",
          value: barPercentage,
          defaultValue: defaults.barPercentage,
          onChange: update => onChange({
            barPercentage: update
          })
        }), /*#__PURE__*/_jsx(PercentageInput, {
          id: categoryPercentageFieldId,
          label: "Category Spacing",
          tooltip: "Adjust the space between groups of bars to make the chart more or less compact.",
          value: categoryPercentage,
          defaultValue: defaults.categoryPercentage,
          onChange: update => onChange({
            categoryPercentage: update
          })
        })]
      }), isModified ? /*#__PURE__*/_jsx(Button, {
        type: "button",
        variant: "delete",
        className: styles.deleteButton,
        onClick: handleDelete,
        children: "Reset to default"
      }) : /*#__PURE__*/_jsx(_Fragment, {})]
    })
  }, updatedAt);
};

const MIN_PERCENTAGE = 0;
const MAX_PERCENTAGE = 100;

const PercentageInput = _ref2 => {
  let {
    id,
    label,
    value,
    defaultValue,
    tooltip,
    onChange
  } = _ref2;
  return /*#__PURE__*/_jsx(Label, {
    forInput: id,
    text: label,
    icon: /*#__PURE__*/_jsx(Tooltip, {
      placement: "bottom",
      content: tooltip,
      children: /*#__PURE__*/_jsx(InfoIcon, {})
    }),
    children: /*#__PURE__*/_jsx(Input, {
      id: id,
      type: "number",
      placeholder: `${defaultValue ?? 0}`,
      min: MIN_PERCENTAGE,
      max: MAX_PERCENTAGE,
      defaultValue: value,
      rightIcon: /*#__PURE__*/_jsx(PercentIcon, {}),
      onKeyDown: e => {
        if (!isValidNumberInputKey(e.key)) {
          e.preventDefault();
        }
      },
      onChange: evt => {
        let update = strToInteger(evt.target.value);
        update = Math.max(Math.min(update, MAX_PERCENTAGE), MIN_PERCENTAGE);
        onChange(update === 0 ? null : update);
      }
    })
  });
};

export default EditorFormFieldsColumnDesign;